import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Typography, useMediaQuery } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const faqData = [
    {
        question: "Why Vibio is different from other link in bio tools?",
        answer: "Vibio gives you a full-screen looping video with your links on top as your link in bio page. So you can draw attention with your personality, your energy and your brand. Additionally, Vibio gives you the analytics that really matter to understand your page.",
    },
    {
        question: "Do I need to make a new video?",
        answer: "No, you don't! You can upload any video you like, whether it's from your camera roll or from your TikTok or Instagram. We recommend 60 seconds maximum and vertical 9:16 format for best results. GIF are also supported.",
    },
    {
        question: "What if I don't have a video yet?",
        answer: "You can totally start building your Vibio page without a video. We highly encourage you to upload a video, so your page can speak to your audience. After all, video is what makes your page yours.",
    },
    {
        question: "Is it easy to switch from other bio tools?",
        answer: "Absolutely! Setup takes 60 seconds. Claim your username, upload your video, add your links. Update your bio link with your new Vibio page. You're all set.",
    },
    {
        question: "How do Revenue Links work?",
        answer: "Tag your shop, affiliate links and sponsor as revenue links. Vibio tracks the traffic that earns separately from other traffic. This way you can easily track how your moentized links are performing.",
    },
    {
        question: "Can I trust Vibio Brand Reports?",
        answer: "We do our best to filter bots and collect accurate traffic and click data on your page. You can generate a Brand Report for any links you have. A Brand Report will contain total visits, CTR percentage, visitor locations and device info.",
    },
    {
        question: "Can I use Vibio for my business?",
        answer: "Absolutely! Vibio is already being used by restaurants, law firms, and boutiques from all parts of the world.",
    },
]

export default function FAQSection() {
    const isMobile = useMediaQuery('(max-width:950px)')

    const styles = {
        container: (isMobile) => ({
            margin: isMobile ? '1.2rem .8rem' : '4rem 14vw',
            padding: isMobile ? '2rem 1.2rem' : '3rem 6vw',
            borderRadius: '40px',
            backgroundColor: 'primary.bg2',
            fontFamily: 'catamaran'
        }),
        accordionStyle: {
            p: '.5rem',
        },
        title: {
            color: 'primary.black',
            fontFamily: 'inherit',
            fontWeight: 900,
            textAlign: 'center',
            m: '0 0 1.6rem 0',
        },
        questionHeader: {
            fontWeight: 600,
            fontSize: '120%',
            background: "#f6f6f6",
            borderRadius: '28px',
            m: '.2rem 0',
            p: '.8rem',
        }
    }

    return (
        <Box id="faq" sx={styles.container(isMobile)}>
            <Chip
                label="FAQ"
                size="small"
                sx={{
                    display: 'flex',
                    width: 'fit-content',
                    m: '0 auto 1rem auto',
                    fontFamily: 'Catamaran',
                    fontWeight: 700,
                    backgroundColor: 'primary.main',
                    color: '#fff',
                }}
            />
            <Typography
                variant={isMobile ? 'h4' : 'h3'}
                component="h3"
                sx={styles.title}
            >
                Got questions?
            </Typography>

            {faqData.map((item, index) => (
                <Accordion key={index} sx={styles.accordionStyle}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index + 1}-content`}
                        id={`panel${index + 1}-header`}
                        sx={styles.questionHeader}
                    >
                        {item.question}
                    </AccordionSummary>
                    <AccordionDetails>
                        {item.answer}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    )
}
